/**
 * barbaraTaskService — the BARBARA space's task collection (`barbaraTasks`).
 *
 * Caregiving for Anthony's aunt: her bills, statements, medical and
 * appointments. This is the most sensitive material in the system, and it is the
 * clearest case for why none of the private spaces hang off a `space` field on a
 * shared collection — the collection IS the wall, a missing rule fails closed,
 * and a mis-scoped query returns nothing rather than returning her medical
 * admin to a teacher.
 *
 * `/barbaraTasks` allows read+write only to isOwner(). No categories, for the
 * same reason as Personal and Owners.
 */

import { createTaskService } from './taskServiceFactory';

const barbaraTaskService = createTaskService({
	tasksCollection: 'barbaraTasks',
	space: 'barbara',
	// categoriesCollection deliberately omitted.
});

export default barbaraTaskService;
